import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { environment } from '../environments/environment';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { AppConfigService } from './services/app-config.service';
import { provideCalAngular } from '@cvx/cal-angular';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { providePrimeNG } from 'primeng/config';
import Material from '@primeng/themes/material';
import { authInterceptor } from './shared/interceptors/authInterceptor.interceptor';

export function initializeApp(appConfig: AppConfigService) {
  return (): Promise<any> => {
    return appConfig.load();
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideClientHydration(),
    provideAnimationsAsync(),
    AppConfigService,
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(AppConfigService));
      return initializerFn();
    }),
    provideCalAngular(environment.calConfig),
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          // darkModeSelector: '.my-app-dark' // for dark mode or to toggle between dark and light mode
          // darkModeSelector: '' // empty for light mode
          darkModeSelector: 'none' // to disable
        }
      },
      inputStyle: 'outlined',
      overlayOptions: {
        // can set default options
      },      
      ripple: false
    }),
    MessageService,
    DatePipe
  ]
};
